"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _useClientEventListener = _interopRequireDefault(require("@sprinx/react-api-client/useClientEventListener"));

var _ProductsCodeListsContext = _interopRequireDefault(require("./ProductsCodeListsContext"));

var _useProductParameterGroupTypesServiceCallAll = _interopRequireDefault(require("./useProductParameterGroupTypesServiceCallAll"));

var _useProductParameterTypesServiceCallAll = _interopRequireDefault(require("./useProductParameterTypesServiceCallAll"));

var _useProductTaxonomiesTypesServiceCallAll = _interopRequireDefault(require("./useProductTaxonomiesTypesServiceCallAll"));

function ProductsCodeListsProvider(_ref) {
  var cacheHook = _ref.cacheHook,
      children = _ref.children,
      clientCode = _ref.clientCode,
      _ref$codeListOptions = _ref.codeListOptions,
      codeListOptions = _ref$codeListOptions === void 0 ? null : _ref$codeListOptions;
  var productParameterGroups = (0, _useProductParameterGroupTypesServiceCallAll.default)({
    clientCode: clientCode
  }, cacheHook, undefined, codeListOptions);
  var productParameters = (0, _useProductParameterTypesServiceCallAll.default)({
    clientCode: clientCode
  }, cacheHook, undefined, codeListOptions);
  var productTaxonomies = (0, _useProductTaxonomiesTypesServiceCallAll.default)(undefined, undefined, undefined, codeListOptions);

  var reloadTaxonomies = function reloadTaxonomies() {
    var taxonomiesReloadData = productTaxonomies[4];
    taxonomiesReloadData();
  };

  (0, _useClientEventListener.default)('v1.productTaxonomies.created', reloadTaxonomies, 'api');
  (0, _useClientEventListener.default)('v1.productTaxonomies.updated', reloadTaxonomies, 'api');
  (0, _useClientEventListener.default)('v1.productTaxonomies.removed', reloadTaxonomies, 'api');
  return _react.default.createElement(_ProductsCodeListsContext.default.Provider, {
    value: {
      productParameterGroups: productParameterGroups,
      productParameters: productParameters,
      productTaxonomies: productTaxonomies
    }
  }, children);
}

ProductsCodeListsProvider.propTypes = {
  /**
   * Hook funkce vracejici cache.
   */
  cacheHook: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.array]),
  children: _propTypes.default.node,
  clientCode: _propTypes.default.string,
  codeListOptions: _propTypes.default.shape({
    disableOnAuth: _propTypes.default.bool
  })
};
ProductsCodeListsProvider.defaultProps = {
  cacheHook: undefined,
  children: null,
  clientCode: undefined,
  codeListOptions: null
};
var _default = ProductsCodeListsProvider;
exports.default = _default;